/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminConvertViewupToViewupPlusInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminConvertViewupToViewupPlusNotFoundAccountDto } from '../../src/model';
// @ts-ignore
import type { AdminConvertViewupToViewupPlusNotFoundPlusTypeDto } from '../../src/model';
// @ts-ignore
import type { AdminDeleteSnsAccountInstagramPostForbiddenPlatformIsNotInstagramDto } from '../../src/model';
// @ts-ignore
import type { AdminDeleteSnsAccountInstagramPostForbiddenSnsAccountIsNotViewupPlusDto } from '../../src/model';
// @ts-ignore
import type { AdminDeleteSnsAccountInstagramPostInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminDeleteSnsAccountInstagramPostNotFoundPostDto } from '../../src/model';
// @ts-ignore
import type { AdminDeleteSnsAccountInstagramPostNotFoundSnsAccountDto } from '../../src/model';
// @ts-ignore
import type { AdminGetSnsAccountInstagramFeedForbiddenPlatformIsNotInstagramDto } from '../../src/model';
// @ts-ignore
import type { AdminGetSnsAccountInstagramFeedForbiddenSnsAccountIsNotViewupPlusDto } from '../../src/model';
// @ts-ignore
import type { AdminGetSnsAccountInstagramFeedInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetSnsAccountInstagramFeedNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminGetSnsAccountInstagramFeedOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetSnsAccountsForMkt24BodyRequestDto } from '../../src/model';
// @ts-ignore
import type { AdminGetSnsAccountsForMkt24OkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetViewupPlusSnsAccountsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetViewupPlusSnsAccountsOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetViewupPlusSnsAccountsReqQueryDto } from '../../src/model';
// @ts-ignore
import type { AdminGetViewupSnsAccountsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetViewupSnsAccountsOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetViewupSnsAccountsReqQueryDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidBadRequestApprovedStatusDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidBadRequestRejectedStatusDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidBadRequestWaitingStatusDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupSnsAccountByViewupSnsAccountUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupSnsAccountByViewupSnsAccountUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupSnsAccountByViewupSnsAccountUuidOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { CreateWithTargetUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminPermissionForbiddenDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminPermissionUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { SetSnsAccountErrorFromMkt24BadRequestDto } from '../../src/model';
// @ts-ignore
import type { SetSnsAccountErrorFromMkt24InternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { SetSnsAccountErrorFromMkt24NotFoundDto } from '../../src/model';
// @ts-ignore
import type { SetSnsAccountErrorFromMkt24ReqBodyDto } from '../../src/model';
// @ts-ignore
import type { SnsAccountListForMkt24Response } from '../../src/model';
/**
 * AdminSnsAccountsApi - axios parameter creator
 * @export
 */
export const AdminSnsAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 뷰업 -> 뷰플 전환
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerAdminConvertViewupToViewupPlus: async (snsAccountUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('adminSnsAccountControllerAdminConvertViewupToViewupPlus', 'snsAccountUuid', snsAccountUuid)
            const localVarPath = `/admin/sns-accounts/viewup/{snsAccountUuid}/convert-to-viewup-plus`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 뷰업 플러스 SNS 계정 목록 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSortEnum} [sort] 정렬 기준
         * @param {AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsOrderEnum} [order] 정렬 순서
         * @param {AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsStatusEnum} [status] 계정 상태
         * @param {AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어
         * @param {string} [startDate] 시작일
         * @param {string} [endDate] 종료일
         * @param {AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsGenderEnum} [gender] 관리자 설정 성별
         * @param {number} [age] 관리자 설정 나이
         * @param {boolean} [isDeleted] 삭제된 계정 포함
         * @param {AdminGetViewupPlusSnsAccountsReqQueryDto} [adminGetViewupPlusSnsAccountsReqQueryDto] 어드민 뷰업 플러스 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerAdminGetViewupPlusSnsAccounts: async (page?: number, limit?: number, sort?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSortEnum, order?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsOrderEnum, status?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsStatusEnum, searchType?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSearchTypeEnum, keyword?: string, startDate?: string, endDate?: string, gender?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsGenderEnum, age?: number, isDeleted?: boolean, adminGetViewupPlusSnsAccountsReqQueryDto?: AdminGetViewupPlusSnsAccountsReqQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/sns-accounts/viewupPlus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (age !== undefined) {
                localVarQueryParameter['age'] = age;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['isDeleted'] = isDeleted;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGetViewupPlusSnsAccountsReqQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 뷰업 SNS 계정 목록 조회
         * @param {AdminSnsAccountControllerAdminGetViewupSnsAccountsGenderEnum} [gender] 관리자 설정 성별
         * @param {number} [age] 관리자 설정 나이
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminSnsAccountControllerAdminGetViewupSnsAccountsSortEnum} [sort] 정렬 기준
         * @param {AdminSnsAccountControllerAdminGetViewupSnsAccountsStatusEnum} [status] 계정 상태
         * @param {AdminSnsAccountControllerAdminGetViewupSnsAccountsSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어
         * @param {string} [startDate] 시작일
         * @param {string} [endDate] 종료일
         * @param {Array<number>} [platformCategoryIds] 플랫폼 카테고리 id 목록
         * @param {boolean} [isDeleted] 삭제된 계정 포함 여부
         * @param {boolean} [isAlbaone] 알바원 연결 여부
         * @param {boolean} [isAlbaoneFeedError] 알바원 피드 에러여부
         * @param {AdminGetViewupSnsAccountsReqQueryDto} [adminGetViewupSnsAccountsReqQueryDto] 어드민 뷰업 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerAdminGetViewupSnsAccounts: async (gender?: AdminSnsAccountControllerAdminGetViewupSnsAccountsGenderEnum, age?: number, page?: number, limit?: number, sort?: AdminSnsAccountControllerAdminGetViewupSnsAccountsSortEnum, status?: AdminSnsAccountControllerAdminGetViewupSnsAccountsStatusEnum, searchType?: AdminSnsAccountControllerAdminGetViewupSnsAccountsSearchTypeEnum, keyword?: string, startDate?: string, endDate?: string, platformCategoryIds?: Array<number>, isDeleted?: boolean, isAlbaone?: boolean, isAlbaoneFeedError?: boolean, adminGetViewupSnsAccountsReqQueryDto?: AdminGetViewupSnsAccountsReqQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/sns-accounts/viewup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (age !== undefined) {
                localVarQueryParameter['age'] = age;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (platformCategoryIds) {
                localVarQueryParameter['platformCategoryIds'] = platformCategoryIds;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['isDeleted'] = isDeleted;
            }

            if (isAlbaone !== undefined) {
                localVarQueryParameter['isAlbaone'] = isAlbaone;
            }

            if (isAlbaoneFeedError !== undefined) {
                localVarQueryParameter['isAlbaoneFeedError'] = isAlbaoneFeedError;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGetViewupSnsAccountsReqQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 뷰업 플러스 SNS 계정 수정
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto} adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid: async (snsAccountUuid: string, adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto: AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid', 'snsAccountUuid', snsAccountUuid)
            // verify required parameter 'adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto' is not null or undefined
            assertParamExists('adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid', 'adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto', adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto)
            const localVarPath = `/admin/sns-accounts/viewupPlus/{snsAccountUuid}`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 뷰업 SNS 계정 수정
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto} adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid: async (snsAccountUuid: string, adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto: AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid', 'snsAccountUuid', snsAccountUuid)
            // verify required parameter 'adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto' is not null or undefined
            assertParamExists('adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid', 'adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto', adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto)
            const localVarPath = `/admin/sns-accounts/viewup/{snsAccountUuid}`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 뷰업 플러스 계정 인스타그램 게시글 삭제
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {string} postId 인스타그램 게시글 id
         * @param {string} url 인스타그램 게시글 url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerDeleteSnsAccountInstagramPost: async (snsAccountUuid: string, postId: string, url: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('adminSnsAccountControllerDeleteSnsAccountInstagramPost', 'snsAccountUuid', snsAccountUuid)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('adminSnsAccountControllerDeleteSnsAccountInstagramPost', 'postId', postId)
            // verify required parameter 'url' is not null or undefined
            assertParamExists('adminSnsAccountControllerDeleteSnsAccountInstagramPost', 'url', url)
            const localVarPath = `/admin/sns-accounts/{snsAccountUuid}/instagram/posts/{postId}`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)))
                .replace(`{${"postId"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [마케팅24 전용] 뷰업 계정 목록 조회
         * @param {AdminSnsAccountControllerGetSnsAccountForMkt24PlatformCategoryEnum} [platformCategory] SNS 플랫폼
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerGetSnsAccountForMkt24: async (platformCategory?: AdminSnsAccountControllerGetSnsAccountForMkt24PlatformCategoryEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/sns-accounts/mkt24`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platformCategory !== undefined) {
                localVarQueryParameter['platformCategory'] = platformCategory;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 sns 계정 인스타그램 피드 조회
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerGetSnsAccountInstagramFeed: async (snsAccountUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('adminSnsAccountControllerGetSnsAccountInstagramFeed', 'snsAccountUuid', snsAccountUuid)
            const localVarPath = `/admin/sns-accounts/{snsAccountUuid}/instagram/posts`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [마케팅24 전용] SNS 계정에 에러 설정
         * @param {string} snsUniqueKey sns 고유키
         * @param {SetSnsAccountErrorFromMkt24ReqBodyDto} setSnsAccountErrorFromMkt24ReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24: async (snsUniqueKey: string, setSnsAccountErrorFromMkt24ReqBodyDto: SetSnsAccountErrorFromMkt24ReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsUniqueKey' is not null or undefined
            assertParamExists('adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24', 'snsUniqueKey', snsUniqueKey)
            // verify required parameter 'setSnsAccountErrorFromMkt24ReqBodyDto' is not null or undefined
            assertParamExists('adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24', 'setSnsAccountErrorFromMkt24ReqBodyDto', setSnsAccountErrorFromMkt24ReqBodyDto)
            const localVarPath = `/admin/sns-accounts/{snsUniqueKey}/error-with-sns-unique-key`
                .replace(`{${"snsUniqueKey"}}`, encodeURIComponent(String(snsUniqueKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSnsAccountErrorFromMkt24ReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [마케팅24 전용] 뷰업 계정 사용 여부 설정
         * @param {string} snsAccountUuid SNS 계정 UUID
         * @param {number} expiredTime 만료 시간
         * @param {string} [snsUniqueKey] SNS 계정 Unique Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerSetUsedMkt24SnsAccount: async (snsAccountUuid: string, expiredTime: number, snsUniqueKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('adminSnsAccountControllerSetUsedMkt24SnsAccount', 'snsAccountUuid', snsAccountUuid)
            // verify required parameter 'expiredTime' is not null or undefined
            assertParamExists('adminSnsAccountControllerSetUsedMkt24SnsAccount', 'expiredTime', expiredTime)
            const localVarPath = `/admin/sns-accounts/mkt24`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (snsAccountUuid !== undefined) {
                localVarQueryParameter['snsAccountUuid'] = snsAccountUuid;
            }

            if (snsUniqueKey !== undefined) {
                localVarQueryParameter['snsUniqueKey'] = snsUniqueKey;
            }

            if (expiredTime !== undefined) {
                localVarQueryParameter['expiredTime'] = expiredTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [마케팅24 전용] 뷰업 계정 정보 조회 API
         * @param {AdminGetSnsAccountsForMkt24BodyRequestDto} adminGetSnsAccountsForMkt24BodyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountListForMkt24: async (adminGetSnsAccountsForMkt24BodyRequestDto: AdminGetSnsAccountsForMkt24BodyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminGetSnsAccountsForMkt24BodyRequestDto' is not null or undefined
            assertParamExists('snsAccountListForMkt24', 'adminGetSnsAccountsForMkt24BodyRequestDto', adminGetSnsAccountsForMkt24BodyRequestDto)
            const localVarPath = `/admin/sns-accounts/mkt24/sns-unique-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGetSnsAccountsForMkt24BodyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSnsAccountsApi - functional programming interface
 * @export
 */
export const AdminSnsAccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSnsAccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 뷰업 -> 뷰플 전환
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSnsAccountControllerAdminConvertViewupToViewupPlus(snsAccountUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSnsAccountControllerAdminConvertViewupToViewupPlus(snsAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.adminSnsAccountControllerAdminConvertViewupToViewupPlus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 뷰업 플러스 SNS 계정 목록 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSortEnum} [sort] 정렬 기준
         * @param {AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsOrderEnum} [order] 정렬 순서
         * @param {AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsStatusEnum} [status] 계정 상태
         * @param {AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어
         * @param {string} [startDate] 시작일
         * @param {string} [endDate] 종료일
         * @param {AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsGenderEnum} [gender] 관리자 설정 성별
         * @param {number} [age] 관리자 설정 나이
         * @param {boolean} [isDeleted] 삭제된 계정 포함
         * @param {AdminGetViewupPlusSnsAccountsReqQueryDto} [adminGetViewupPlusSnsAccountsReqQueryDto] 어드민 뷰업 플러스 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSnsAccountControllerAdminGetViewupPlusSnsAccounts(page?: number, limit?: number, sort?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSortEnum, order?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsOrderEnum, status?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsStatusEnum, searchType?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSearchTypeEnum, keyword?: string, startDate?: string, endDate?: string, gender?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsGenderEnum, age?: number, isDeleted?: boolean, adminGetViewupPlusSnsAccountsReqQueryDto?: AdminGetViewupPlusSnsAccountsReqQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetViewupPlusSnsAccountsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSnsAccountControllerAdminGetViewupPlusSnsAccounts(page, limit, sort, order, status, searchType, keyword, startDate, endDate, gender, age, isDeleted, adminGetViewupPlusSnsAccountsReqQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.adminSnsAccountControllerAdminGetViewupPlusSnsAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 뷰업 SNS 계정 목록 조회
         * @param {AdminSnsAccountControllerAdminGetViewupSnsAccountsGenderEnum} [gender] 관리자 설정 성별
         * @param {number} [age] 관리자 설정 나이
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminSnsAccountControllerAdminGetViewupSnsAccountsSortEnum} [sort] 정렬 기준
         * @param {AdminSnsAccountControllerAdminGetViewupSnsAccountsStatusEnum} [status] 계정 상태
         * @param {AdminSnsAccountControllerAdminGetViewupSnsAccountsSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어
         * @param {string} [startDate] 시작일
         * @param {string} [endDate] 종료일
         * @param {Array<number>} [platformCategoryIds] 플랫폼 카테고리 id 목록
         * @param {boolean} [isDeleted] 삭제된 계정 포함 여부
         * @param {boolean} [isAlbaone] 알바원 연결 여부
         * @param {boolean} [isAlbaoneFeedError] 알바원 피드 에러여부
         * @param {AdminGetViewupSnsAccountsReqQueryDto} [adminGetViewupSnsAccountsReqQueryDto] 어드민 뷰업 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSnsAccountControllerAdminGetViewupSnsAccounts(gender?: AdminSnsAccountControllerAdminGetViewupSnsAccountsGenderEnum, age?: number, page?: number, limit?: number, sort?: AdminSnsAccountControllerAdminGetViewupSnsAccountsSortEnum, status?: AdminSnsAccountControllerAdminGetViewupSnsAccountsStatusEnum, searchType?: AdminSnsAccountControllerAdminGetViewupSnsAccountsSearchTypeEnum, keyword?: string, startDate?: string, endDate?: string, platformCategoryIds?: Array<number>, isDeleted?: boolean, isAlbaone?: boolean, isAlbaoneFeedError?: boolean, adminGetViewupSnsAccountsReqQueryDto?: AdminGetViewupSnsAccountsReqQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetViewupSnsAccountsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSnsAccountControllerAdminGetViewupSnsAccounts(gender, age, page, limit, sort, status, searchType, keyword, startDate, endDate, platformCategoryIds, isDeleted, isAlbaone, isAlbaoneFeedError, adminGetViewupSnsAccountsReqQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.adminSnsAccountControllerAdminGetViewupSnsAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 뷰업 플러스 SNS 계정 수정
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto} adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid(snsAccountUuid: string, adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto: AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid(snsAccountUuid, adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 뷰업 SNS 계정 수정
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto} adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid(snsAccountUuid: string, adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto: AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchViewupSnsAccountByViewupSnsAccountUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid(snsAccountUuid, adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 뷰업 플러스 계정 인스타그램 게시글 삭제
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {string} postId 인스타그램 게시글 id
         * @param {string} url 인스타그램 게시글 url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSnsAccountControllerDeleteSnsAccountInstagramPost(snsAccountUuid: string, postId: string, url: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSnsAccountControllerDeleteSnsAccountInstagramPost(snsAccountUuid, postId, url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.adminSnsAccountControllerDeleteSnsAccountInstagramPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [마케팅24 전용] 뷰업 계정 목록 조회
         * @param {AdminSnsAccountControllerGetSnsAccountForMkt24PlatformCategoryEnum} [platformCategory] SNS 플랫폼
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSnsAccountControllerGetSnsAccountForMkt24(platformCategory?: AdminSnsAccountControllerGetSnsAccountForMkt24PlatformCategoryEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminGetSnsAccountsForMkt24OkDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSnsAccountControllerGetSnsAccountForMkt24(platformCategory, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.adminSnsAccountControllerGetSnsAccountForMkt24']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 sns 계정 인스타그램 피드 조회
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSnsAccountControllerGetSnsAccountInstagramFeed(snsAccountUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetSnsAccountInstagramFeedOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSnsAccountControllerGetSnsAccountInstagramFeed(snsAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.adminSnsAccountControllerGetSnsAccountInstagramFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [마케팅24 전용] SNS 계정에 에러 설정
         * @param {string} snsUniqueKey sns 고유키
         * @param {SetSnsAccountErrorFromMkt24ReqBodyDto} setSnsAccountErrorFromMkt24ReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24(snsUniqueKey: string, setSnsAccountErrorFromMkt24ReqBodyDto: SetSnsAccountErrorFromMkt24ReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24(snsUniqueKey, setSnsAccountErrorFromMkt24ReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [마케팅24 전용] 뷰업 계정 사용 여부 설정
         * @param {string} snsAccountUuid SNS 계정 UUID
         * @param {number} expiredTime 만료 시간
         * @param {string} [snsUniqueKey] SNS 계정 Unique Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSnsAccountControllerSetUsedMkt24SnsAccount(snsAccountUuid: string, expiredTime: number, snsUniqueKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSnsAccountControllerSetUsedMkt24SnsAccount(snsAccountUuid, expiredTime, snsUniqueKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.adminSnsAccountControllerSetUsedMkt24SnsAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [마케팅24 전용] 뷰업 계정 정보 조회 API
         * @param {AdminGetSnsAccountsForMkt24BodyRequestDto} adminGetSnsAccountsForMkt24BodyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountListForMkt24(adminGetSnsAccountsForMkt24BodyRequestDto: AdminGetSnsAccountsForMkt24BodyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnsAccountListForMkt24Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountListForMkt24(adminGetSnsAccountsForMkt24BodyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSnsAccountsApi.snsAccountListForMkt24']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSnsAccountsApi - factory interface
 * @export
 */
export const AdminSnsAccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSnsAccountsApiFp(configuration)
    return {
        /**
         * 
         * @summary 뷰업 -> 뷰플 전환
         * @param {AdminSnsAccountsApiAdminSnsAccountControllerAdminConvertViewupToViewupPlusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerAdminConvertViewupToViewupPlus(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerAdminConvertViewupToViewupPlusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminSnsAccountControllerAdminConvertViewupToViewupPlus(requestParameters.snsAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 뷰업 플러스 SNS 계정 목록 조회
         * @param {AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerAdminGetViewupPlusSnsAccounts(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccountsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetViewupPlusSnsAccountsOkDto> {
            return localVarFp.adminSnsAccountControllerAdminGetViewupPlusSnsAccounts(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.order, requestParameters.status, requestParameters.searchType, requestParameters.keyword, requestParameters.startDate, requestParameters.endDate, requestParameters.gender, requestParameters.age, requestParameters.isDeleted, requestParameters.adminGetViewupPlusSnsAccountsReqQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 뷰업 SNS 계정 목록 조회
         * @param {AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerAdminGetViewupSnsAccounts(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccountsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetViewupSnsAccountsOkDto> {
            return localVarFp.adminSnsAccountControllerAdminGetViewupSnsAccounts(requestParameters.gender, requestParameters.age, requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.status, requestParameters.searchType, requestParameters.keyword, requestParameters.startDate, requestParameters.endDate, requestParameters.platformCategoryIds, requestParameters.isDeleted, requestParameters.isAlbaone, requestParameters.isAlbaoneFeedError, requestParameters.adminGetViewupSnsAccountsReqQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 뷰업 플러스 SNS 계정 수정
         * @param {AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidOkDto> {
            return localVarFp.adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid(requestParameters.snsAccountUuid, requestParameters.adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 뷰업 SNS 계정 수정
         * @param {AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchViewupSnsAccountByViewupSnsAccountUuidOkDto> {
            return localVarFp.adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid(requestParameters.snsAccountUuid, requestParameters.adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 뷰업 플러스 계정 인스타그램 게시글 삭제
         * @param {AdminSnsAccountsApiAdminSnsAccountControllerDeleteSnsAccountInstagramPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerDeleteSnsAccountInstagramPost(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerDeleteSnsAccountInstagramPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminSnsAccountControllerDeleteSnsAccountInstagramPost(requestParameters.snsAccountUuid, requestParameters.postId, requestParameters.url, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [마케팅24 전용] 뷰업 계정 목록 조회
         * @param {AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountForMkt24Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerGetSnsAccountForMkt24(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountForMkt24Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminGetSnsAccountsForMkt24OkDto>> {
            return localVarFp.adminSnsAccountControllerGetSnsAccountForMkt24(requestParameters.platformCategory, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 sns 계정 인스타그램 피드 조회
         * @param {AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountInstagramFeedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerGetSnsAccountInstagramFeed(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountInstagramFeedRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetSnsAccountInstagramFeedOkDto> {
            return localVarFp.adminSnsAccountControllerGetSnsAccountInstagramFeed(requestParameters.snsAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [마케팅24 전용] SNS 계정에 에러 설정
         * @param {AdminSnsAccountsApiAdminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24(requestParameters.snsUniqueKey, requestParameters.setSnsAccountErrorFromMkt24ReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [마케팅24 전용] 뷰업 계정 사용 여부 설정
         * @param {AdminSnsAccountsApiAdminSnsAccountControllerSetUsedMkt24SnsAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSnsAccountControllerSetUsedMkt24SnsAccount(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerSetUsedMkt24SnsAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminSnsAccountControllerSetUsedMkt24SnsAccount(requestParameters.snsAccountUuid, requestParameters.expiredTime, requestParameters.snsUniqueKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [마케팅24 전용] 뷰업 계정 정보 조회 API
         * @param {AdminSnsAccountsApiSnsAccountListForMkt24Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountListForMkt24(requestParameters: AdminSnsAccountsApiSnsAccountListForMkt24Request, options?: RawAxiosRequestConfig): AxiosPromise<SnsAccountListForMkt24Response> {
            return localVarFp.snsAccountListForMkt24(requestParameters.adminGetSnsAccountsForMkt24BodyRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminSnsAccountControllerAdminConvertViewupToViewupPlus operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiAdminSnsAccountControllerAdminConvertViewupToViewupPlusRequest
 */
export interface AdminSnsAccountsApiAdminSnsAccountControllerAdminConvertViewupToViewupPlusRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminConvertViewupToViewupPlus
     */
    readonly snsAccountUuid: string
}

/**
 * Request parameters for adminSnsAccountControllerAdminGetViewupPlusSnsAccounts operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccountsRequest
 */
export interface AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccountsRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly limit?: number

    /**
     * 정렬 기준
     * @type {'point' | 'updatedAt'}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly sort?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSortEnum

    /**
     * 정렬 순서
     * @type {'asc' | 'desc'}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly order?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsOrderEnum

    /**
     * 계정 상태
     * @type {'all' | 'pending' | 'waiting' | 'approved' | 'rejected' | 'stop'}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly status?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsStatusEnum

    /**
     * 검색 타입
     * @type {'id' | 'snsId'}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly searchType?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSearchTypeEnum

    /**
     * 검색어
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly keyword?: string

    /**
     * 시작일
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly startDate?: string

    /**
     * 종료일
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly endDate?: string

    /**
     * 관리자 설정 성별
     * @type {'M' | 'F' | 'unknown'}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly gender?: AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsGenderEnum

    /**
     * 관리자 설정 나이
     * @type {number}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly age?: number

    /**
     * 삭제된 계정 포함
     * @type {boolean}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly isDeleted?: boolean

    /**
     * 어드민 뷰업 플러스 SNS 계정 목록 조회
     * @type {AdminGetViewupPlusSnsAccountsReqQueryDto}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccounts
     */
    readonly adminGetViewupPlusSnsAccountsReqQueryDto?: AdminGetViewupPlusSnsAccountsReqQueryDto
}

/**
 * Request parameters for adminSnsAccountControllerAdminGetViewupSnsAccounts operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccountsRequest
 */
export interface AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccountsRequest {
    /**
     * 관리자 설정 성별
     * @type {'M' | 'F' | 'unknown'}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly gender?: AdminSnsAccountControllerAdminGetViewupSnsAccountsGenderEnum

    /**
     * 관리자 설정 나이
     * @type {number}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly age?: number

    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly limit?: number

    /**
     * 정렬 기준
     * @type {'latest' | 'oldest'}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly sort?: AdminSnsAccountControllerAdminGetViewupSnsAccountsSortEnum

    /**
     * 계정 상태
     * @type {'all' | 'waiting' | 'approved' | 'rejected'}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly status?: AdminSnsAccountControllerAdminGetViewupSnsAccountsStatusEnum

    /**
     * 검색 타입
     * @type {'id' | 'snsId'}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly searchType?: AdminSnsAccountControllerAdminGetViewupSnsAccountsSearchTypeEnum

    /**
     * 검색어
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly keyword?: string

    /**
     * 시작일
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly startDate?: string

    /**
     * 종료일
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly endDate?: string

    /**
     * 플랫폼 카테고리 id 목록
     * @type {Array<number>}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly platformCategoryIds?: Array<number>

    /**
     * 삭제된 계정 포함 여부
     * @type {boolean}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly isDeleted?: boolean

    /**
     * 알바원 연결 여부
     * @type {boolean}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly isAlbaone?: boolean

    /**
     * 알바원 피드 에러여부
     * @type {boolean}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly isAlbaoneFeedError?: boolean

    /**
     * 어드민 뷰업 SNS 계정 목록 조회
     * @type {AdminGetViewupSnsAccountsReqQueryDto}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccounts
     */
    readonly adminGetViewupSnsAccountsReqQueryDto?: AdminGetViewupSnsAccountsReqQueryDto
}

/**
 * Request parameters for adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidRequest
 */
export interface AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid
     */
    readonly snsAccountUuid: string

    /**
     * 
     * @type {AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid
     */
    readonly adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto: AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto
}

/**
 * Request parameters for adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuidRequest
 */
export interface AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuidRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid
     */
    readonly snsAccountUuid: string

    /**
     * 
     * @type {AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid
     */
    readonly adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto: AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto
}

/**
 * Request parameters for adminSnsAccountControllerDeleteSnsAccountInstagramPost operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiAdminSnsAccountControllerDeleteSnsAccountInstagramPostRequest
 */
export interface AdminSnsAccountsApiAdminSnsAccountControllerDeleteSnsAccountInstagramPostRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerDeleteSnsAccountInstagramPost
     */
    readonly snsAccountUuid: string

    /**
     * 인스타그램 게시글 id
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerDeleteSnsAccountInstagramPost
     */
    readonly postId: string

    /**
     * 인스타그램 게시글 url
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerDeleteSnsAccountInstagramPost
     */
    readonly url: string
}

/**
 * Request parameters for adminSnsAccountControllerGetSnsAccountForMkt24 operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountForMkt24Request
 */
export interface AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountForMkt24Request {
    /**
     * SNS 플랫폼
     * @type {'instagram' | 'youtube' | 'facebook' | 'nblog' | 'googleplay' | 'appstore' | 'kakaochannel' | 'naverband' | 'web' | 'threads'}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountForMkt24
     */
    readonly platformCategory?: AdminSnsAccountControllerGetSnsAccountForMkt24PlatformCategoryEnum
}

/**
 * Request parameters for adminSnsAccountControllerGetSnsAccountInstagramFeed operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountInstagramFeedRequest
 */
export interface AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountInstagramFeedRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountInstagramFeed
     */
    readonly snsAccountUuid: string
}

/**
 * Request parameters for adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24 operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiAdminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24Request
 */
export interface AdminSnsAccountsApiAdminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24Request {
    /**
     * sns 고유키
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24
     */
    readonly snsUniqueKey: string

    /**
     * 
     * @type {SetSnsAccountErrorFromMkt24ReqBodyDto}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24
     */
    readonly setSnsAccountErrorFromMkt24ReqBodyDto: SetSnsAccountErrorFromMkt24ReqBodyDto
}

/**
 * Request parameters for adminSnsAccountControllerSetUsedMkt24SnsAccount operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiAdminSnsAccountControllerSetUsedMkt24SnsAccountRequest
 */
export interface AdminSnsAccountsApiAdminSnsAccountControllerSetUsedMkt24SnsAccountRequest {
    /**
     * SNS 계정 UUID
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerSetUsedMkt24SnsAccount
     */
    readonly snsAccountUuid: string

    /**
     * 만료 시간
     * @type {number}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerSetUsedMkt24SnsAccount
     */
    readonly expiredTime: number

    /**
     * SNS 계정 Unique Key
     * @type {string}
     * @memberof AdminSnsAccountsApiAdminSnsAccountControllerSetUsedMkt24SnsAccount
     */
    readonly snsUniqueKey?: string
}

/**
 * Request parameters for snsAccountListForMkt24 operation in AdminSnsAccountsApi.
 * @export
 * @interface AdminSnsAccountsApiSnsAccountListForMkt24Request
 */
export interface AdminSnsAccountsApiSnsAccountListForMkt24Request {
    /**
     * 
     * @type {AdminGetSnsAccountsForMkt24BodyRequestDto}
     * @memberof AdminSnsAccountsApiSnsAccountListForMkt24
     */
    readonly adminGetSnsAccountsForMkt24BodyRequestDto: AdminGetSnsAccountsForMkt24BodyRequestDto
}

/**
 * AdminSnsAccountsApi - object-oriented interface
 * @export
 * @class AdminSnsAccountsApi
 * @extends {BaseAPI}
 */
export class AdminSnsAccountsApi extends BaseAPI {
    /**
     * 
     * @summary 뷰업 -> 뷰플 전환
     * @param {AdminSnsAccountsApiAdminSnsAccountControllerAdminConvertViewupToViewupPlusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public adminSnsAccountControllerAdminConvertViewupToViewupPlus(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerAdminConvertViewupToViewupPlusRequest, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).adminSnsAccountControllerAdminConvertViewupToViewupPlus(requestParameters.snsAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 뷰업 플러스 SNS 계정 목록 조회
     * @param {AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public adminSnsAccountControllerAdminGetViewupPlusSnsAccounts(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupPlusSnsAccountsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).adminSnsAccountControllerAdminGetViewupPlusSnsAccounts(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.order, requestParameters.status, requestParameters.searchType, requestParameters.keyword, requestParameters.startDate, requestParameters.endDate, requestParameters.gender, requestParameters.age, requestParameters.isDeleted, requestParameters.adminGetViewupPlusSnsAccountsReqQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 뷰업 SNS 계정 목록 조회
     * @param {AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public adminSnsAccountControllerAdminGetViewupSnsAccounts(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerAdminGetViewupSnsAccountsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).adminSnsAccountControllerAdminGetViewupSnsAccounts(requestParameters.gender, requestParameters.age, requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.status, requestParameters.searchType, requestParameters.keyword, requestParameters.startDate, requestParameters.endDate, requestParameters.platformCategoryIds, requestParameters.isDeleted, requestParameters.isAlbaone, requestParameters.isAlbaoneFeedError, requestParameters.adminGetViewupSnsAccountsReqQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 뷰업 플러스 SNS 계정 수정
     * @param {AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).adminSnsAccountControllerAdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuid(requestParameters.snsAccountUuid, requestParameters.adminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 뷰업 SNS 계정 수정
     * @param {AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).adminSnsAccountControllerAdminPatchViewupSnsAccountBySnsAccountUuid(requestParameters.snsAccountUuid, requestParameters.adminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 뷰업 플러스 계정 인스타그램 게시글 삭제
     * @param {AdminSnsAccountsApiAdminSnsAccountControllerDeleteSnsAccountInstagramPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public adminSnsAccountControllerDeleteSnsAccountInstagramPost(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerDeleteSnsAccountInstagramPostRequest, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).adminSnsAccountControllerDeleteSnsAccountInstagramPost(requestParameters.snsAccountUuid, requestParameters.postId, requestParameters.url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [마케팅24 전용] 뷰업 계정 목록 조회
     * @param {AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountForMkt24Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public adminSnsAccountControllerGetSnsAccountForMkt24(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountForMkt24Request = {}, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).adminSnsAccountControllerGetSnsAccountForMkt24(requestParameters.platformCategory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 sns 계정 인스타그램 피드 조회
     * @param {AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountInstagramFeedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public adminSnsAccountControllerGetSnsAccountInstagramFeed(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerGetSnsAccountInstagramFeedRequest, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).adminSnsAccountControllerGetSnsAccountInstagramFeed(requestParameters.snsAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [마케팅24 전용] SNS 계정에 에러 설정
     * @param {AdminSnsAccountsApiAdminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24Request, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).adminSnsAccountControllerSetSnsAccountErrorWithSnsUniqueKeyFromMkt24(requestParameters.snsUniqueKey, requestParameters.setSnsAccountErrorFromMkt24ReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [마케팅24 전용] 뷰업 계정 사용 여부 설정
     * @param {AdminSnsAccountsApiAdminSnsAccountControllerSetUsedMkt24SnsAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public adminSnsAccountControllerSetUsedMkt24SnsAccount(requestParameters: AdminSnsAccountsApiAdminSnsAccountControllerSetUsedMkt24SnsAccountRequest, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).adminSnsAccountControllerSetUsedMkt24SnsAccount(requestParameters.snsAccountUuid, requestParameters.expiredTime, requestParameters.snsUniqueKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [마케팅24 전용] 뷰업 계정 정보 조회 API
     * @param {AdminSnsAccountsApiSnsAccountListForMkt24Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSnsAccountsApi
     */
    public snsAccountListForMkt24(requestParameters: AdminSnsAccountsApiSnsAccountListForMkt24Request, options?: RawAxiosRequestConfig) {
        return AdminSnsAccountsApiFp(this.configuration).snsAccountListForMkt24(requestParameters.adminGetSnsAccountsForMkt24BodyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSortEnum = {
    Point: 'point',
    UpdatedAt: 'updatedAt'
} as const;
export type AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSortEnum = typeof AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSortEnum[keyof typeof AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSortEnum];
/**
 * @export
 */
export const AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsOrderEnum = typeof AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsOrderEnum[keyof typeof AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsOrderEnum];
/**
 * @export
 */
export const AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsStatusEnum = {
    All: 'all',
    Pending: 'pending',
    Waiting: 'waiting',
    Approved: 'approved',
    Rejected: 'rejected',
    Stop: 'stop'
} as const;
export type AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsStatusEnum = typeof AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsStatusEnum[keyof typeof AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsStatusEnum];
/**
 * @export
 */
export const AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSearchTypeEnum = {
    Id: 'id',
    SnsId: 'snsId'
} as const;
export type AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSearchTypeEnum = typeof AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSearchTypeEnum[keyof typeof AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsSearchTypeEnum];
/**
 * @export
 */
export const AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;
export type AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsGenderEnum = typeof AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsGenderEnum[keyof typeof AdminSnsAccountControllerAdminGetViewupPlusSnsAccountsGenderEnum];
/**
 * @export
 */
export const AdminSnsAccountControllerAdminGetViewupSnsAccountsGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;
export type AdminSnsAccountControllerAdminGetViewupSnsAccountsGenderEnum = typeof AdminSnsAccountControllerAdminGetViewupSnsAccountsGenderEnum[keyof typeof AdminSnsAccountControllerAdminGetViewupSnsAccountsGenderEnum];
/**
 * @export
 */
export const AdminSnsAccountControllerAdminGetViewupSnsAccountsSortEnum = {
    Latest: 'latest',
    Oldest: 'oldest'
} as const;
export type AdminSnsAccountControllerAdminGetViewupSnsAccountsSortEnum = typeof AdminSnsAccountControllerAdminGetViewupSnsAccountsSortEnum[keyof typeof AdminSnsAccountControllerAdminGetViewupSnsAccountsSortEnum];
/**
 * @export
 */
export const AdminSnsAccountControllerAdminGetViewupSnsAccountsStatusEnum = {
    All: 'all',
    Waiting: 'waiting',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;
export type AdminSnsAccountControllerAdminGetViewupSnsAccountsStatusEnum = typeof AdminSnsAccountControllerAdminGetViewupSnsAccountsStatusEnum[keyof typeof AdminSnsAccountControllerAdminGetViewupSnsAccountsStatusEnum];
/**
 * @export
 */
export const AdminSnsAccountControllerAdminGetViewupSnsAccountsSearchTypeEnum = {
    Id: 'id',
    SnsId: 'snsId'
} as const;
export type AdminSnsAccountControllerAdminGetViewupSnsAccountsSearchTypeEnum = typeof AdminSnsAccountControllerAdminGetViewupSnsAccountsSearchTypeEnum[keyof typeof AdminSnsAccountControllerAdminGetViewupSnsAccountsSearchTypeEnum];
/**
 * @export
 */
export const AdminSnsAccountControllerGetSnsAccountForMkt24PlatformCategoryEnum = {
    Instagram: 'instagram',
    Youtube: 'youtube',
    Facebook: 'facebook',
    Nblog: 'nblog',
    Googleplay: 'googleplay',
    Appstore: 'appstore',
    Kakaochannel: 'kakaochannel',
    Naverband: 'naverband',
    Web: 'web',
    Threads: 'threads'
} as const;
export type AdminSnsAccountControllerGetSnsAccountForMkt24PlatformCategoryEnum = typeof AdminSnsAccountControllerGetSnsAccountForMkt24PlatformCategoryEnum[keyof typeof AdminSnsAccountControllerGetSnsAccountForMkt24PlatformCategoryEnum];
